import i18n from 'i18n-js';

import { AlertBoxSimple } from '../../components';

import { TEMPLATES_TITLES } from '../templates';

export const ALERTBOX_COMPONENTS = {
  [TEMPLATES_TITLES.ALERTBOX_SIMPLE]: AlertBoxSimple,
};

export const ALERTBOX_DESIGNS_DATA = {
  [TEMPLATES_TITLES.ALERTBOX_SIMPLE]: {
    design: {
      styles: [
        {
          id: 1,
          title: i18n.t('screens.builder.design.title'),
          value: 'title',
          items: [
            {
              id: 101,
              label: i18n.t('screens.builder.design.highlightColor'),
              type: 'color',
              value: 'primary',
            },
            {
              id: 102,
              label: i18n.t('screens.builder.design.fontColor'),
              type: 'color',
              value: 'color',
            },
            {
              id: 103,
              label: i18n.t('screens.builder.design.fontFamily'),
              type: 'fontFamily',
              value: 'font',
            },
            {
              id: 104,
              label: i18n.t('screens.builder.design.fontSize'),
              min: 10,
              max: 90,
              step: 5,
              type: 'slider',
              value: 'size',
            },
            {
              id: 105,
              label: i18n.t('screens.builder.design.letterSpacing'),
              min: 0,
              max: 30,
              step: 1,
              type: 'slider',
              value: 'letterSpacing',
            },
          ],
        },
        {
          id: 2,
          title: i18n.t('screens.builder.design.message'),
          value: 'message',
          items: [
            {
              id: 200,
              label: i18n.t('screens.builder.design.fontColor'),
              type: 'color',
              value: 'color',
            },
            {
              id: 201,
              label: i18n.t('screens.builder.design.fontFamily'),
              type: 'fontFamily',
              value: 'font',
            },
            {
              id: 202,
              label: i18n.t('screens.builder.design.fontSize'),
              min: 20,
              max: 70,
              step: 5,
              type: 'slider',
              value: 'size',
            },
            {
              id: 203,
              label: i18n.t('screens.builder.design.letterSpacing'),
              min: 0,
              max: 30,
              step: 1,
              type: 'slider',
              value: 'letterSpacing',
            },
          ],
        },
      ],
    },
  },
};

export default {
  ALERTBOX_COMPONENTS,
  ALERTBOX_DESIGNS_DATA,
};
